import { Modal } from "react-bootstrap";
import "./GalleryPopUpQuiz.scss";
import { useState, useEffect } from "react";
import { useUserContext } from "@/context/UserContext";
import { object, boolean, string } from "yup";
import { useFormik } from "formik";
import { newRecommendationQuiz } from "@/services/RecommendationQuizService";
import CustomSpinner from "../CustomSpinner/CustomSpinner";
import { notifyError, notifySuccess } from "@/utils/NotificationFunctions";
import { updateUserRecommendation } from "@/services/EditProfileService";
import { incrementPageAndViewCount } from "@/services/UserService";
import { useGalleryContext } from "@/context/GalleryContext";
import Link from "next/link";
const yodaPic = "../../assets/images/yoda-baby.jpg";
interface GalleryPopUpPropsI {
  show: boolean;
  onHide: () => void;
}
type Select = "" | "yes" | "no";
const loginSchema = object({
  answer: boolean().required("Answer is required"),
  why: string().when("answer", {
    is: (value: any) => !value,
    then: (schema: any) => schema.required("Why is required"),
  }),
});
function GalleryPopUpQuiz(props: GalleryPopUpPropsI) {
  const { show, onHide } = props;

  const [notShow, setNotShow] = useState<boolean>(false);
  const { currentUser, userToken, fetchUserData } = useUserContext();
  const { setIsQuizAnswered } = useGalleryContext();

  const [loader, setLoader] = useState<boolean>(false);
  const [selected, setSelected] = useState<Select>("");
  const initialValues = {
    answer: null,
    why: "",
    user: "",
  };
  const handleSelect = (option: Select) => {
    if (selected === option) {
      setSelected("");
      setFieldValue("answer", null);
    } else {
      setSelected(option);
      if (option === "yes") {
        setFieldValue("answer", true);
      } else {
        setFieldValue("answer", false);
      }
    }
  };
  const handleCloseModal = async () => {
    onHide();
  };

  useEffect(() => {
    if (show) {
      incrementViewCount();
      //setNotShow(true);
    }
  }, [show]);

  const incrementViewCount = async () => {
    try {
      let userId = "";
      if (currentUser) userId = currentUser._id;

      const res = await incrementPageAndViewCount(userId, userToken);
    } catch (error) {
      console.error("Failed to increment view count", error);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoader(true);
      const body = {
        ...values,
        user: currentUser?._id || undefined,
        why: !values.answer ? values.why : "",
      };
      const user = {
        userId: currentUser?._id || undefined,
        data: {
          recommendationQuizStatus: true,
        },
      };
      try {
        const create = await newRecommendationQuiz(body, userToken);

        if (!currentUser) {
          const isQuizAnswered = localStorage.setItem("isQuizAnswered", "true");
          setIsQuizAnswered(isQuizAnswered);
        }

        if (currentUser) {
          const updateUser = await updateUserRecommendation(user, userToken);
        }
        fetchUserData();
        notifySuccess("Form submitted");
      } catch (error: any) {
        notifyError(error);
      }
      onHide();
      setLoader(false);
    },
  });
  const { setFieldValue } = formik;
  return (
    <Modal className="gallery-pop-up-modal" show={show} centered>
      <Modal.Body>
        <img src={yodaPic} alt="yoda" />
        <div className="text-container">
          <p>
            Like the concept of the resource? Sending the link to your friends
            would make its progress way faster.
          </p>
          <p>
            Share your referral link to gain points, that later will be
            converted into CelebStory NFTs and can be sold for a fixed price.
            Check{" "}
            <Link href={"/NFTprogram"} className="a-class">
              celebstory.com/NFTprogram
            </Link>
          </p>
        </div>
        <form
          className="inputs-contain"
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <div className="input-ctn" onClick={() => handleSelect("yes")}>
            <div className={"radio " + (selected === "yes" ? "selected" : "")}>
              <div className="inner-dot" />
            </div>
            <label>Ok, I will</label>
          </div>
          <div className="with-input">
            <div className="input-ctn" onClick={() => handleSelect("no")}>
              <div className={"radio " + (selected === "no" ? "selected" : "")}>
                <div className="inner-dot" />
              </div>
              <label>I'd rather not</label>
            </div>
            <textarea
              id="why"
              name="why"
              onChange={formik.handleChange}
              placeholder="Why?"
            />
          </div>
          <div className="button-ctn">
            {loader ? (
              <div className="spinner-ctn">
                <CustomSpinner size={2} borderWidth={1} />
              </div>
            ) : (
              <>
                <button className="btn linear-bg" type="submit">
                  Send
                </button>
                <button
                  className="btn linear-bg"
                  type="button"
                  onClick={handleCloseModal}
                >
                  I'll answer later
                </button>
              </>
            )}
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default GalleryPopUpQuiz;
